 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtimechunk~app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtimechunk~app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"app.activate":"app.activate","app.client-base":"app.client-base","app.dashboard":"app.dashboard","app.feedbacks":"app.feedbacks","app.forgot-password":"app.forgot-password","app.invite-loading":"app.invite-loading","app.login":"app.login","app.register":"app.register","app.resend-activation":"app.resend-activation","app.reset-password":"app.reset-password","app.revoke-access":"app.revoke-access","default~app.account~app.support":"default~app.account~app.support","app.support":"app.support","default~app.account~app.branch-offices~app.org-booking-page~app.records~app.services~app.settings~ap~a3ac2929":"default~app.account~app.branch-offices~app.org-booking-page~app.records~app.services~app.settings~ap~a3ac2929","app.records":"app.records","app.workspaces-page":"app.workspaces-page","default~app.account~app.branch-offices":"default~app.account~app.branch-offices","app.account":"app.account","app.branch-offices":"app.branch-offices","default~app.org-booking-page~app.services~app.widget~app.workspaces":"default~app.org-booking-page~app.services~app.widget~app.workspaces","app.org-booking-page":"app.org-booking-page","app.widget":"app.widget","default~app.services~app.workspaces":"default~app.services~app.workspaces","app.services":"app.services","default~app.settings~app.workspaces":"default~app.settings~app.workspaces","app.workspaces":"app.workspaces","app.settings":"app.settings","error-403":"error-403","error-404":"error-404","error-500":"error-500"}[chunkId]||chunkId) + "." + {"chunk-2d20e7c2":"30977dbe","chunk-2d22bcc3":"96377d74","app.activate":"58974130","app.client-base":"1d6d7b5b","app.dashboard":"ef06a705","app.feedbacks":"66cfefdf","app.forgot-password":"57ad7caa","app.invite-loading":"f79c5f79","app.login":"7a09cdc3","app.register":"21ccc9fb","app.resend-activation":"c44d0102","app.reset-password":"ef8c8343","app.revoke-access":"64239b73","chunk-1e6da32b":"35c73a92","chunk-7cf8a33a":"2cfee9be","default~app.account~app.support":"b6dd35ed","app.support":"96e11bbc","default~app.account~app.branch-offices~app.org-booking-page~app.records~app.services~app.settings~ap~a3ac2929":"9c1689ec","app.records":"baf63292","app.workspaces-page":"a7c05592","default~app.account~app.branch-offices":"3a1575ae","app.account":"dbc9d67d","app.branch-offices":"b87d76e4","default~app.org-booking-page~app.services~app.widget~app.workspaces":"f2693711","app.org-booking-page":"c068fbdc","app.widget":"ccf7050a","default~app.services~app.workspaces":"7358691a","app.services":"7fc4c8b1","default~app.settings~app.workspaces":"85078432","app.workspaces":"2f5d674f","app.settings":"5efd3440","error-403":"332dcddd","error-404":"338d65e2","error-500":"ba0e98a9","chunk-2d0d3a1a":"d264d820"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"app.activate":1,"app.client-base":1,"app.dashboard":1,"app.feedbacks":1,"app.forgot-password":1,"app.invite-loading":1,"app.resend-activation":1,"app.reset-password":1,"app.revoke-access":1,"chunk-1e6da32b":1,"chunk-7cf8a33a":1,"app.records":1,"default~app.account~app.branch-offices":1,"app.branch-offices":1,"default~app.org-booking-page~app.services~app.widget~app.workspaces":1,"app.org-booking-page":1,"app.widget":1,"default~app.services~app.workspaces":1,"app.services":1,"default~app.settings~app.workspaces":1,"app.workspaces":1,"app.settings":1,"error-403":1,"error-404":1,"error-500":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "assets/css/" + ({"app.activate":"app.activate","app.client-base":"app.client-base","app.dashboard":"app.dashboard","app.feedbacks":"app.feedbacks","app.forgot-password":"app.forgot-password","app.invite-loading":"app.invite-loading","app.login":"app.login","app.register":"app.register","app.resend-activation":"app.resend-activation","app.reset-password":"app.reset-password","app.revoke-access":"app.revoke-access","default~app.account~app.support":"default~app.account~app.support","app.support":"app.support","default~app.account~app.branch-offices~app.org-booking-page~app.records~app.services~app.settings~ap~a3ac2929":"default~app.account~app.branch-offices~app.org-booking-page~app.records~app.services~app.settings~ap~a3ac2929","app.records":"app.records","app.workspaces-page":"app.workspaces-page","default~app.account~app.branch-offices":"default~app.account~app.branch-offices","app.account":"app.account","app.branch-offices":"app.branch-offices","default~app.org-booking-page~app.services~app.widget~app.workspaces":"default~app.org-booking-page~app.services~app.widget~app.workspaces","app.org-booking-page":"app.org-booking-page","app.widget":"app.widget","default~app.services~app.workspaces":"default~app.services~app.workspaces","app.services":"app.services","default~app.settings~app.workspaces":"default~app.settings~app.workspaces","app.workspaces":"app.workspaces","app.settings":"app.settings","error-403":"error-403","error-404":"error-404","error-500":"error-500"}[chunkId]||chunkId) + "." + {"chunk-2d20e7c2":"31d6cfe0","chunk-2d22bcc3":"31d6cfe0","app.activate":"3e27d7d6","app.client-base":"93be15c1","app.dashboard":"96b19148","app.feedbacks":"e304e853","app.forgot-password":"7588fbd8","app.invite-loading":"24f6f620","app.login":"31d6cfe0","app.register":"31d6cfe0","app.resend-activation":"7588fbd8","app.reset-password":"7588fbd8","app.revoke-access":"7588fbd8","chunk-1e6da32b":"5dbbaca0","chunk-7cf8a33a":"d86f1340","default~app.account~app.support":"31d6cfe0","app.support":"31d6cfe0","default~app.account~app.branch-offices~app.org-booking-page~app.records~app.services~app.settings~ap~a3ac2929":"31d6cfe0","app.records":"89084ce4","app.workspaces-page":"31d6cfe0","default~app.account~app.branch-offices":"8b83c3ef","app.account":"31d6cfe0","app.branch-offices":"38492e13","default~app.org-booking-page~app.services~app.widget~app.workspaces":"b13537f7","app.org-booking-page":"00422f7d","app.widget":"2c2da389","default~app.services~app.workspaces":"e405433c","app.services":"89fa51ca","default~app.settings~app.workspaces":"8bb81959","app.workspaces":"2d9032b9","app.settings":"bad9e3be","error-403":"fd79da1b","error-404":"fd79da1b","error-500":"fd79da1b","chunk-2d0d3a1a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
